import { Controller } from "@hotwired/stimulus"

export default class MissingFrameController extends Controller {
  redirectAfterMissingFrame(event) {
    event.preventDefault()
    event.detail.visit(event.detail.response)
  }
}
